import { z } from 'zod';
import { baseCustomFieldSchema } from '@/features/dashboard/tourCustomFields/schemas/baseCustomFieldSchema.ts';
import { FieldType } from '@/components/table/_fieldDefinitions/FieldType.ts';

export const dropdownCustomFieldSchema = baseCustomFieldSchema.extend({
  type: z.literal(FieldType.DROPDOWN),
  placeholder: z.string(),
  options: z
    .array(
      z.object({
        id: z.string().optional(),
        label: z
          .string({ error: 'Nazwa opcji jest wymagana' })
          .min(1, 'Minimum 1 znak'),
      }),
    )
    .min(1, 'Dodaj przynajmniej jedną opcję'),
});

export type DropdownCustomFieldInputData = z.input<
  typeof dropdownCustomFieldSchema
>;
export type DropdownCustomFieldFormData = z.infer<
  typeof dropdownCustomFieldSchema
>;
